import { get } from "svelte/store";

import { notMouseEvent }               from "lib/mouse-events";
import { showTooltip, getTooltipText } from "lib/text-tooltip";

import { activeQuote } from "stores/active-quote";
import { balance }     from "stores/balance";
import { prompt }      from "stores/prompt";

function triggerBalancePreview(e, quote) {
    let previewGems  = get(balance).gems;
    let previewCoins = get(balance).coins;

    if (!get(activeQuote).disabled) {
        previewGems  = quote.type === "gems" ?
            get(balance).gems + quote.quantity :
            get(balance).gems - quote.price;
        previewCoins = quote.type === "coins" ?
            get(balance).coins + quote.quantity :
            get(balance).coins - quote.price;
    }

    balance.updateBalance({
        type      : "gems",
        amount    : previewGems,
        isPreview : true
    });
    balance.updateBalance({
        type      : "coins",
        amount    : previewCoins,
        isPreview : true
    });
}

function doNothing(e) {
    if (notMouseEvent(e)) {
        return true;
    }

    if (get(prompt) && !e.forced) {
        return true;
    }
}

/**
 * Handle hovering and quotes
 * @param {object} opts
 * @param {boolean} opts.featureDisabled - exchange might be disabled for account type, based on config
 * @param {object} opts.quote - 2 props: quantity, price
 * @param {object} e - mouse event
 */
function onQuoteMouseover({ featureDisabled, exchangeType, quote }, e) {
    if (doNothing(e)) {
        return;
    }

    activeQuote.setActiveQuote(quote);

    if (!featureDisabled) {
        triggerBalancePreview(e, quote);
    }

    showTooltip(e, getTooltipText({ featureDisabled, exchangeType }));
}

/**
 * Mouseover
 * @param {object} opts
 * @param {boolean} opts.unavailable
 * @param {object} opts.quote - 2 props: quantity, price
 * @param {object} e - mouse event
 */
function onQuoteMouseout({ featureDisabled, quote }, e) {
    if (doNothing(e)) {
        return;
    }

    activeQuote.clear();

    if (!featureDisabled) {
        triggerBalancePreview(e, quote);
    }

    showTooltip(e, null);
}

export {
    onQuoteMouseover,
    onQuoteMouseout
};
